var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.5,49c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S43.706,49,41.5,49z M41.5,55c-1.103,0-2-0.897-2-2s0.897-2,2-2   s2,0.897,2,2S42.603,55,41.5,55z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,5h4c0.552,0,1-0.447,1-1s-0.448-1-1-1h-4c-0.552,0-1,0.447-1,1S36.948,5,37.5,5z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,5h1c0.552,0,1-0.447,1-1s-0.448-1-1-1h-1c-0.552,0-1,0.447-1,1S43.948,5,44.5,5z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.095,0H28.905C26.476,0,24.5,1.977,24.5,4.405v9.534c-5.254,2.019-9,7.104-9,13.061c0,3.258,1.128,6.253,3.002,8.634   L1.816,51.271c-0.403,0.378-0.424,1.011-0.046,1.413C1.967,52.894,2.233,53,2.5,53c0.245,0,0.491-0.09,0.684-0.271l16.663-15.615   c1.33,1.27,2.907,2.276,4.653,2.947v15.534c0,2.429,1.976,4.405,4.405,4.405h25.189c2.429,0,4.405-1.977,4.405-4.405V4.405   C58.5,1.977,56.524,0,54.095,0z M28.905,2h25.189C55.421,2,56.5,3.079,56.5,4.405V6h-30V4.405C26.5,3.079,27.579,2,28.905,2z    M17.5,27c0-5.339,3.507-9.87,8.336-11.423c0.158-0.051,0.318-0.09,0.477-0.134c0.185-0.051,0.37-0.102,0.558-0.144   c0.162-0.037,0.325-0.067,0.489-0.097c0.213-0.039,0.427-0.072,0.644-0.099c0.136-0.017,0.272-0.036,0.408-0.048   C28.771,15.022,29.133,15,29.5,15c6.617,0,12,5.383,12,12s-5.383,12-12,12c-0.367,0-0.729-0.022-1.088-0.055   c-0.136-0.013-0.272-0.031-0.408-0.048c-0.216-0.027-0.431-0.06-0.644-0.099c-0.163-0.03-0.326-0.061-0.489-0.097   c-0.188-0.042-0.373-0.093-0.558-0.144c-0.159-0.044-0.319-0.083-0.477-0.134C21.007,36.87,17.5,32.339,17.5,27z M27.8,40.886   c0.071,0.009,0.142,0.025,0.214,0.033C28.503,40.971,28.998,41,29.5,41c7.72,0,14-6.28,14-14s-6.28-14-14-14   c-0.502,0-0.997,0.029-1.486,0.081c-0.072,0.008-0.142,0.024-0.214,0.033c-0.422,0.051-0.84,0.117-1.25,0.205   c-0.017,0.004-0.033,0.005-0.05,0.008V8h30v38h-30v-5.327c0.017,0.003,0.033,0.004,0.05,0.008   C26.96,40.77,27.378,40.835,27.8,40.886z M54.095,58H28.905c-1.326,0-2.405-1.079-2.405-2.405V48h30v7.595   C56.5,56.921,55.421,58,54.095,58z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#3a444d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.f8f2940ed55250d557e4e6d5b9c96733.svg";
export { ForwardRef as ReactComponent };